import React from 'react'
import styled from '@emotion/styled';
import css from '@emotion/css';

const size = {
    mobile: '767px',
    ipad: '768px',
    laptop: '1300px',
    //desktop: '1440px',
  }
  
const device = {
    mobile: `(max-width: ${size.mobile})`,
    nomobile: `(min-width: ${size.ipad})`,
    laptop: `(min-width: ${size.ipad}) and (max-width: ${size.laptop})`,
};

interface IStyledTabs {
  state?: string;
}

export const Tabs = (props:any) => {
  return (
    <TabWrapper>
      <Tab>
        {
          Array.isArray(props.data) && props.data.map((innerData: any)=>{
          return <TabList state={innerData.type === props.active ? 'active' : ''}>
              <a onClick={()=> props.onTabChange(innerData)}>{innerData.name}</a>
            </TabList>
          })
        }
      </Tab>
    </TabWrapper>
  )
}

const TabWrapper = styled.div`
@media screen and ${device.mobile},
screen and (orientation: landscape) and (max-width: 1000px) {
  width:100%;
  padding:12px 0;
  margin: 0 0 5px;
  background: #fff;
}
`

const Tab = styled.ul`
  padding: 4px;
  border-radius: 100px;
  border: solid 1px #e4e4e4;
  background-color: #fff;
  margin: 18px 0;
  display: flex;
  justify-content:center;
  width: max-content;
  margin: 0 auto;
  @media screen and ${device.mobile},
  screen and (orientation: landscape) and (max-width: 1000px) {
    margin: 0;
    border-radius: 0px;
    width: 100%;
    border-width: 2px 0px 2px 0px;
    border-color: #FFF5F6;
    padding: 0;
  }
`;
const TabList = styled.li<IStyledTabs>`
  display: inline-block;
  min-width: 235px;
  padding: 10px;
  text-align: center;
  font-size: 18px;
  line-height: 20px;
  font-weight: 400;
  cursor: pointer;
  position: relative;
  a{
    color: #000;
  }

  ${(props: IStyledTabs) => props.state == "active" && css`
        border-radius: 100px;
        background-color: #e21b23;
        a{
          color: #fff;
          font-weight: bold;
        }
  `}
  
   @media screen and ${device.mobile},
  screen and (orientation: landscape) and (max-width: 1000px) {
    min-width: auto;
    display:flex;
    align-items: center;
    height: 64px;
    border-right: 2px solid #FFF5F6;
    flex: 1;
    justify-content: center;
    &:last-child{
      border-right:0px;
    }
    ${(props: IStyledTabs) => props.state == "active" && css`
      background: none;
      border-radius: 0;
      border-bottom: 2px solid #E21B22;
      a{
        color: #E21B22;

      }
      &:after {
        border: solid #E21B22;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 3px;
        transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        content: '';
        position: absolute;
        bottom: -6px;
        background: #fff;
      }
    `
  } 
`;

